
























import Vue from "vue";

export default Vue.extend({
  name: "Account",
  computed: {
    getHeaders() {
      return "";
    },
  },
  props: {
    source: String,
  },
});
